module.exports = __webpack_public_path__ + "static/media/shop-gold-backing.dbc2615d.png";